<template>
  <div>
    <b-field>
      <b-input
        v-model="enteredWord"
        placeholder="Enter the hidden word"
        icon-right="spell-check"
        icon-right-clickable
        :disabled="disabled"
        @icon-right-click="checkWord"
        @keyup.native.enter="checkWord"
      ></b-input>
    </b-field>
    <p class="prev-word has-text-centered">
      {{ previousWord }}
      <b-icon
        v-if="previousWordCorrect === true"
        pack="fas"
        icon="check"
        type="is-success"
      ></b-icon>
      <b-icon
        v-if="previousWordCorrect === false"
        pack="fas"
        icon="times"
        type="is-danger"
      ></b-icon>
    </p>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["currentHiddenWord", "currentHiddenWordId", "bookId"],
  computed: {
    canCheck() {
      return this.enteredWord.trim().length > 0;
    },
    disabled() {
      return !this.currentHiddenWord;
    }
  },
  data() {
    return {
      enteredWord: "",
      previousWord: "...",
      previousWordCorrect: undefined
    };
  },
  methods: {
    ...mapActions(["recordSpelling"]),
    checkWord() {
      if (!this.canCheck) return;
      const correct =
        this.enteredWord.trim().localeCompare(this.currentHiddenWord, "en", {
          sensitivity: "base"
        }) === 0;
      this.recordSpelling({ bookId: this.bookId, correct: correct });
      this.$parent.$emit(
        "hiddenWordCheckResult",
        this.currentHiddenWordId,
        correct
      );
      this.previousWord = this.enteredWord;
      this.previousWordCorrect = correct;
      this.enteredWord = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.prev-word .icon {
  display: inline;
}
</style>
